import AMAServiceClient from '../clients/AMAServiceClient';
import selectors from '../../rootSelectors';
import { COMPREHENSION } from '../../constants/assessmentItemType';
import { CLPL, MAZE } from '../../constants/measure';
import CLPL_FORM_NUMBER from '../../constants/queryParam';
import { getURLParam } from '../utils/browserUtils';
import MazeServiceClient from '../clients/MazeServiceClient';
import AssessmentFormsServiceClient from '../clients/AssessmentFormsServiceClient';
import { MAZE_FETCH_RETRY } from './apiRetryGetConstants';

const getCLPLFormIdFromUrl = grade => {
    return getURLParam(CLPL_FORM_NUMBER)
        ? `clpl_${grade}_pm_${getURLParam(CLPL_FORM_NUMBER)}`
        : null;
};

export const fetchNextFormId = (
    studentId,
    period,
    obsMeasure,
    secure,
    retryActionName,
    setFormAction,
) => (dispatch, getState) => {
    const state = getState();
    const grade = selectors.getGrade(state);
    const requestedCLPLFormId = getCLPLFormIdFromUrl(grade);
    return dispatch(
        AMAServiceClient.getNextFormId(studentId, period, obsMeasure, secure, retryActionName),
    )
        .then(form => {
            if (requestedCLPLFormId) {
                const formData = {
                    next_form_id: requestedCLPLFormId,
                    measure: CLPL.MEASURE,
                    measure_type: COMPREHENSION,
                };
                dispatch(setFormAction(formData));
                return null;
            }
            // in case of no content response, empty object is returned
            // so make sure that there is next form id to set
            if (form && form.next_form_id) {
                dispatch(setFormAction(form));
                return form.next_form_id;
            }
            return null;
        })
        .then(formId => {
            // Prefetch MAZE form to cache it in offline mode
            if (obsMeasure === MAZE.MEASURE && formId) {
                const formFetchPromise = secure
                    ? AssessmentFormsServiceClient.getSecureForm(
                          formId,
                          selectors.getSchoolYear(state),
                          MAZE_FETCH_RETRY,
                      )
                    : MazeServiceClient.getForm(null, null, formId, MAZE_FETCH_RETRY);
                return dispatch(formFetchPromise);
            }
            return null;
        });
};

export default fetchNextFormId;
